export default "/img/BR.c466ce6ae31e6d0520c3efd48f110c44.png";